module.exports = __webpack_public_path__ + "img/maternity-icon.70b726f9.png";